import { openZohoChat } from '../utils/openZohoChat';
import Icon from './Icon';

export default function ChatDock() {
  return (
    <button type="button" className="chat-dock" onClick={openZohoChat} aria-label="Open live chat">
      <Icon name="chat" size={22} />
      <span>Live Chat</span>
    </button>
  );
}
